var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cancel-btn" }, [
    _c("i", { staticClass: "cancel-icon fa fa-phone" }),
    _c("span", { staticClass: "cancel-text" }, [
      _vm._v(_vm._s(_vm.$t("radio-red-btn")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }